import { ReactNode } from "react";

export function ExternalShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto py-3">
          <img src="/allmark-logo.png" alt="Allmark" className="h-8" />
        </div>
      </header>
      <main className="container mx-auto py-8">{children}</main>
      <footer className="border-t mt-12 py-4 text-center text-xs text-muted-foreground">
        Allmark
      </footer>
    </div>
  );
}
